import { render, staticRenderFns } from "./TalkizyJoinTeam.vue?vue&type=template&id=5f925496&"
import script from "./TalkizyJoinTeam.vue?vue&type=script&lang=js&"
export * from "./TalkizyJoinTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports